<template>
  <section class="admin-block">
    <div class="section-title">
        <h2>System Information</h2>
        <button v-if="!isFetching" class="icon-button" type="button" @click="isFetching || fetchSystemStatistics()" aria-label="Refresh system information"><ion-icon name="refresh-circle-outline"></ion-icon></button>
        <div v-else>
            <div class="spinner-grow text-primary" role="status"></div>
        </div>
    </div>

    <div class="card mb-3">
      <h5 class="card-header">CPU</h5>
      <div class="card-body">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">Total Cores</th>
              <th scope="col" v-for="n in systemInfo.cpu_cores" :key="'core-header-' + n">
                Core {{ n }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ systemInfo.cpu_cores }}</td>
              <td v-for="(usage, index) in systemInfo.cpu_usage_per_core" :key="'cpu-usage-' + index">
                {{ usage }}%
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <h5 class="card-header border-top">Memory</h5>
      <div class="card-body">
        <table class="table">
          <thead>
            <tr>
              <th>Total Memory (GB)</th>
              <th>Used Memory (GB)</th>
              <th>Free Memory (GB)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ bytesToGigabytes(systemInfo.memory_total) }}</td>
              <td>{{ bytesToGigabytes(systemInfo.memory_used) }}</td>
              <td>{{ bytesToGigabytes(systemInfo.memory_free) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <h5 class="card-header border-top">Disk</h5>
      <div class="card-body">
        <table class="table">
          <thead>
            <tr>
              <th>Total Disk (GB)</th>
              <th>Used Disk (GB)</th>
              <th>Free Disk (GB)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ bytesToGigabytes(systemInfo.disk_total) }}</td>
              <td>{{ bytesToGigabytes(systemInfo.disk_used) }}</td>
              <td>{{ bytesToGigabytes(systemInfo.disk_free) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <h5 class="card-header border-top">Network</h5>
      <div class="card-body">
        <table class="table">
          <thead>
            <tr>
              <th>Sent Data (MB)</th>
              <th>Received Data (MB)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ bytesToMegabytes(systemInfo.network_sent) }}</td>
              <td>{{ bytesToMegabytes(systemInfo.network_recv) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </section>
</template>

<script>
import AdminService from '@/services/admin.service.js';

export default {
  name: 'AdminSystem',
  data() {
    return {
      systemInfo: {},
      isFetching: false
    };
  },

  methods: {
    bytesToGigabytes(bytes) {
      return (bytes / 1024 ** 3).toFixed(2);
    },
    bytesToMegabytes(bytes) {
      return (bytes / 1024 ** 2).toFixed(2);
    },
    fetchSystemStatistics() {
        if (this.isFetching) return;
        this.isFetching = true;

        AdminService.getSystemStatistics()
        .then(data => {
            this.systemInfo = data.system_info;
            this.isFetching = false;
        })
        .catch(() => {
            AdminService.removeAdmin();
            this.$root.$emit('FooterUpdateEvent');
            this.$router.push({ path: '/' });
            this.isFetching = false;
        });
    }
  },

    mounted: function() {
        this.fetchSystemStatistics();
    },
};
</script>

<style scoped>
.admin-block {
  width: 100%;
  margin-bottom: 2rem;
}

.section-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
}

.section-title h2 {
  margin: 0;
  font-size: 1.6rem;
}

.icon-button {
  width: 3rem;
  height: 3rem;
  display: inline-grid;
  place-items: center;
  border: 2px solid var(--ss-line);
  border-radius: 999px;
  background: var(--ss-yellow);
  color: var(--ss-ink);
  font-size: 1.55rem;
  box-shadow: 0 4px 0 var(--ss-line);
}

.card {
  overflow: hidden;
}
</style>
